import { fullNameSchema } from "@/shared/schema/full-name";
import z from "zod";

export const AuthSchema = z.object({
  full_name: fullNameSchema,
  // username: usernameSchema,
  is_user_confirmed_age: z.boolean(),
});

export type AuthPayload = z.infer<typeof AuthSchema>;
